import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Empty, Loader } from "@/components/Page";

import { WikiArticleCard } from "@/components/wiki/WikiArticleCard";
import { WikiChrome } from "@/components/wiki/WikiChrome";
import { WikiMarkdown } from "@/components/wiki/WikiMarkdown";

export default function WikiArticle() {
  const { categorySlug, articleSlug } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    api.get(`/wiki/article/${categorySlug}/${articleSlug}`).then((res) => setData(res.data)).catch((error) => {
      toast.error(apiErr(error));
      setData(false);
    });
  }, [articleSlug, categorySlug]);

  if (data === null) return <Loader label="Opening article…" />;
  if (data === false) return <Empty label="This wiki article could not be opened." />;

  const article = data.article;
  return (
    <WikiChrome title={article.title} subtitle={article.excerpt || data.category.description} categories={data.categories} liveSidebar={data.live_sidebar}>
      <div className="text-xs uppercase tracking-[0.22em] text-zinc-500"><Link to="/wiki" className="hover:text-amber-300">Wiki Home</Link> / <Link to={`/wiki/${data.category.slug}`} className="hover:text-amber-300">{data.category.title}</Link> / {article.title}</div>

      <section className="border border-amber-900/20 bg-zinc-950/55 p-5 sm:p-7 space-y-6">
        <div className="flex flex-wrap items-center gap-2">
          {article.tags?.map((tag) => <span key={tag} data-testid={`wiki-article-tag-${tag}`} className="border border-zinc-800 bg-zinc-950 px-2.5 py-1 text-[11px] uppercase tracking-[0.22em] text-zinc-400">{tag}</span>)}
        </div>
        <WikiMarkdown>{article.body_markdown}</WikiMarkdown>
      </section>

      <section className="space-y-4">
        <h2 className="font-cinzel text-xl text-amber-200">Related Articles</h2>
        {data.related_articles.length === 0 ? <Empty label="No related articles linked yet." /> : <div className="grid gap-4 md:grid-cols-2">{data.related_articles.map((item) => <WikiArticleCard key={item.id} article={item} compact />)}</div>}
      </section>
    </WikiChrome>
  );
}